import { CobaltSearchField } from '@cae/cobalt-react/components/search-field';
import { useInstructorsFilter } from '@features/instructors/contexts/filter/useInstructorsFilter';
import { useSearchField } from '@shared/hooks/use-search-field/useSearchField';
import * as React from 'react';

import type { InstructorsSearchProps } from './InstructorsSearch.types';

import styles from './InstructorsSearch.module.css';

const InstructorsSearch = React.memo(
  ({
    disabled = false,
  }: Readonly<InstructorsSearchProps>): React.ReactElement => {
    const { filters, setFilters } = useInstructorsFilter();

    const { localValue, handleChange, handleClear } = useSearchField({
      value: filters.searchText,
      onSearch: (searchText: string) => setFilters({ searchText }),
    });

    return (
      <CobaltSearchField
        hasClear={true}
        placeholder="Search by name"
        value={localValue}
        onChange={handleChange}
        onClear={handleClear}
        disabled={disabled}
        className={styles.instructorsSearch}
        data-testid="instructors-search"
      />
    );
  }
);

InstructorsSearch.displayName = 'InstructorsSearch';
export { InstructorsSearch };
